import { GetStaticProps, GetStaticPaths } from 'next';
import { getAllPostContents, getRedirectPaths } from '@api';

import { PostPage } from '@components';
import { getStaticPropsCore } from '@/src/getStatic/getStaticPropsCore';
import { pathsFromPosts } from '@/src/pages/knowledge/blog/[slug]/[page]';

export const getStaticProps = async ({
  params,
}: Parameters<GetStaticProps<any, { slug: string; page: string }>>[0]) => {
  console.info(`getStaticProps /interview/${params?.slug}/${params?.page}`);
  return await getStaticPropsCore(params?.slug || '', {
    pageInPost: Number(params?.page),
    pathIsInterview: true,
  });
};

export const getStaticPaths: GetStaticPaths<{
  slug: string;
  page: string;
}> = async () => {
  const redirects = await getRedirectPaths();
  const posts = await getAllPostContents({
    where: { search: 'nextpage', categoryName: 'interview' },
  });

  return {
    paths: pathsFromPosts(posts).filter(
      (path) => !redirects.has(`/knowledge/interview/${path.params.slug}/`)
    ),
    fallback: 'blocking',
  };
};

export default PostPage;
